import { useEffect } from "react";
import { MemoryRouter, Routes, Route, Navigate, useNavigate } from "react-router";
import { useWidgetListener } from "@/hooks";
import {
  AmlCheck,
  AmlCheckDetails,
  AmlHistory,
  Home,
  PostPayment,
  ErrorPage,
} from "@/pages";
import { PAGES } from "@/config/pages";

const AppRoutes = () => {
  const navigate = useNavigate();
  useWidgetListener();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const clientSecret = params.get('payment_intent_client_secret');
   
    if (clientSecret) {
      navigate(
        `${PAGES.POST_PAYMENT}${window.location.search}`, 
        { replace: true }
      );
    }
  }, [navigate]);

  return (
    <Routes>
      <Route path={PAGES.HOME} element={<Home />} />
      <Route path={PAGES.AML_HISTORY} element={<AmlHistory />} />
      <Route path={PAGES.POST_PAYMENT} element={<PostPayment />} />
      <Route path={PAGES.AML_CHECK} element={<AmlCheck />} />
      <Route path={PAGES.AML_CHECK_DETAILS} element={<AmlCheckDetails />} />
      <Route path={PAGES.ERROR_PAGE} element={<ErrorPage />} />
      <Route path="*" element={<Navigate to={PAGES.AML_HISTORY} />} />
    </Routes>
  );
};

const App = () => {
  return (
    <MemoryRouter>
      <AppRoutes />
    </MemoryRouter>
  );
};

export default App;
